<pinch-zoom disableZoomControl="disable" backgroundColor="rgba(0,0,0,0)" class="w-100 h-100">
	<img class="pinch-zoom-content" [src]="$file().data.fileUrl | https" (error)="onError()" />
</pinch-zoom>

@if ($showError()) {
	<div class="w-100 h-100 pos-abs pos-t-0 pos-l-0 fl fl-ai-c fl-jc-c bg">
		<i class="icon-warning-white fc-warn" style="font-size: 100px"></i>
	</div>
}
